import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'


const baseQuery = fetchBaseQuery({
  baseUrl: process.env.REACT_APP_API_URL,
  prepareHeaders: (headers) => {
    const token = localStorage.getItem('authtoken');
    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);

  if (result.error && (result.error.status === 401 || result.error.status === 403)) {
    localStorage.removeItem('authtoken');
  }
  return result;
};


export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getUserlist: builder.query({
      query: () => ({
        url: `/accounts/users/`,
        
      }),
    }),
    postUser: builder.mutation({
      query: (data) => ({
        url: `/accounts/attendances-create/`,
        method: "POST",
        body: data,
      }),
    }),

        getMobileUserlist: builder.query({
      query: () => ({
        url: `/accounts/mobile/users/`,
      }),
    }),

  }),
})

export const { useGetUserlistQuery, usePostUserMutation,useGetMobileUserlistQuery } = userApi